// extracted by mini-css-extract-plugin
export var carousel = "carouselTestimonials-module--carousel--343b5";
export var carouselContainer = "carouselTestimonials-module--carouselContainer--4fdba";
export var containerQuote = "carouselTestimonials-module--containerQuote--ce2d6";
export var quote = "carouselTestimonials-module--quote--3de94";
export var removeTestimonial = "carouselTestimonials-module--removeTestimonial--b6e13";